import ChevronLeft from '@assets/icons/chevron-left.svg?react'
import ChevronRight from '@assets/icons/chevron-right.svg?react'
import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import { type ReactNode, useEffect, useState } from 'react'
import { ThreeCircles } from 'react-loader-spinner'

type SelectBankItemProps = {
  back?: boolean
  icon?: ReactNode
  caption?: string
  description?: string
  selected?: boolean
  onClick: () => void
  loading: boolean
  maintenance?: boolean
  [key: string]: any
}

const SelectBankItem = (props: SelectBankItemProps) => {
  const { back, caption, description, icon, selected, onClick, loading, maintenance, className, ...rest } = props

  const [visible, setVisible] = useState(false)

  const handleClick = () => {
    if (!loading) {
      onClick()
    }
  }

  useEffect(() => {
    setVisible(true)
    return () => {
      setVisible(false)
    }
  }, [])

  return (
    <div
      className={cn('select-bank-item-wrapper', className, { visible: visible, back, selected, maintenance })}
      onClick={handleClick}
      {...rest}
    >
      {back ? (
        <span className='back-arrow'>
          <ChevronLeft />
        </span>
      ) : (
        <span className='icon'>{icon}</span>
      )}

      <div className='custom-select-text'>
        {caption ? <span className='caption'>{caption}</span> : null}
        {description ? <span>{description}</span> : null}
        {maintenance ? (
          <span className='warning'>{tr('CHECKOUT.VOUCHER.BANKS.MAINTENANCE', 'Under maintenance')}</span>
        ) : null}
      </div>

      {!back && selected ? (
        <span className='arrow'>
          {loading ? <ThreeCircles width='3.5rem' height='3.5rem' color='white' /> : <ChevronRight />}
        </span>
      ) : null}
    </div>
  )
}

export default SelectBankItem
